<template>
  <svg class="w-0 h-0" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="paint0_linear" x1="10" x2="114" y1="7" y2="119" gradientUnits="userSpaceOnUse">
        <stop stop-color="#8CABBE" />
        <stop offset="1" stop-color="#415A8B" />
      </linearGradient>

      <filter id="filter" width="132" height="140" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="-4" dy="-4" />
        <feGaussianBlur stdDeviation="6" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 0.8875 0 0 0 0 0.948864 0 0 0 0.08 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="4" dy="4" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix values="0 0 0 0 0.513726 0 0 0 0 0.0941176 0 0 0 0 0.262745 0 0 0 0.8 0" />
        <feBlend in2="effect1_dropShadow" result="effect2_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
      </filter>

      <linearGradient id="paint1_linear" x1="0" x2="414" y1="30" y2="685" gradientUnits="userSpaceOnUse">
        <stop stop-color="#B12554" />
        <stop offset="1" stop-color="#9D1744" />
      </linearGradient>

      <filter id="filter1" width="462" height="827.98" x="-24" y="0" color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="-6" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix values="0 0 0 0 0.108333 0 0 0 0 0.0338542 0 0 0 0 0.058914 0 0 0 0.15 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>

      <symbol id="tile" viewBox="0 0 132 142" preserveAspectRatio="none">
        <g filter="url(#filter)">
          <path fill="url(#paint0_linear)" d="M56 18.46a12 12 0 0112 0l33.03 19.08a12 12 0 016 10.39v38.14a12 12 0 01-6 10.4L68 115.53a12 12 0 01-12 0L22.97 96.46a12 12 0 01-6-10.39V47.93a12 12 0 016-10.4L56 18.47z" />
        </g>
      </symbol>

      <!-- Red curved bg on startpage - xMidYMin slice -->
      <symbol id="intersection" viewBox="0 0 414 685" x="0" y="0" preserveAspectRatio="none">
        <g filter="url(#filter1)">
          <path fill="url(#paint1_linear)" d="M414 123.9V810H0V82.1l256.13-50.33a93 93 0 0180.17 22.15L414 123.9z" />
        </g>
      </symbol>

    </defs>
  </svg>
</template>
